const initialState = {
  selected: null,
  dragging: false,
  dragSource: null,
  dragSourceHeight: 32,
  hoveringElement: null,
  hoverDirection: null,
  resizing: false,
  resizingElement: null,
  editMode: true,
  error: null,
  savingPage: false,
  iframeLoaded: false,
  filesBeingDragged: null,
  showingOverlay: false
};

const editor = (state = initialState, action) => {
  switch (action.type) {
    case "IFRAME_LOADED": {
      return {
        ...state,
        iframeLoaded: true
      };
    }
    case "SELECT_ELEMENT":
      return {
        ...state,
        ...action.payload
      };
    case "SAVE_PAGE_START":
      return {
        ...state,
        savingPage: true
      };
    case "SAVE_PAGE_END":
      return {
        ...state,
        savingPage: false
      };
    case "SET_ERROR":
      return {
        ...state,
        error: action.payload
      };
    case "DRAG_ACTION":
      return {
        ...state,
        ...action.payload
      };
    case "START_RESIZE":
      return {
        ...state,
        resizing: true,
        resizingElement: action.payload
      };
    case "END_RESIZE":
      return {
        ...state,
        resizing: false,
        resizingElement: null
      };
    case "HOVER_ACTION":
      return {
        ...state,
        ...action.payload
      };
    case "CHANGE_OVERLAY":
      return {
        ...state,
        showingOverlay: action.payload
      };
    default:
      return state;
  }
};

export default editor;
